<template>
  <div
    id="conversational-commerce-page"
    :class="['bg-white position-relative', { 'border-top': free_trial_height > 0 }]"
    :style="isFreeTrialStyle">
    <b-row no-gutters class="h-100">
      <b-col md="3" class="border-right">
        <PanelHeader ref="leftPanelHeader">
          <BrandDropdown />
        </PanelHeader>
        <InboxPanel />
      </b-col>
      <b-col md="6" class="border-right position-relative">
        <PanelHeader class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0 mr-2">{{ customerName }}</h3>
          <div class="cc-center-tools flex-shrink-0">
            <b-button
              id="cc-cart"
              class="p-0 mr-3 border-0 shadow-none position-relative"
              :disabled="!customerName"
              @click="showCartItems">
              <span class="cart-count position-relative px-1" v-if="cartItems && customerName">
                {{ cartItems.cart_count }}
              </span>
            </b-button>
            <b-button id="cc-three-dots" class="p-0 border-0 shadow-none"></b-button>
          </div>
        </PanelHeader>
        <ThreadPanel />
      </b-col>
      <b-col md="3">
        <PanelHeader
          class="d-flex align-items-center justify-content-end"
          ref="rightPanelHeader">
          <b-button id="cc-settings" class="p-0 border-0 shadow-none mr-3">
          </b-button>
          <b-button id="cc-goback" @click="$router.go(-1)" class="py-0 bg-transparent shadow-none d-inline-flex align-items-center">
            <img src="~@/assets/images/icons/close.svg" alt="Close" class="img-fluid mr-2">
            <span class="border-left py-2 pl-2 h-100">Close</span>
          </b-button>
        </PanelHeader>
        <ProductListingPanel ref="productListingPanel" />
      </b-col>
    </b-row>
    <AddOrderModal />
    <CartContents />
    <ProductViewModal />
    <ChangeBranchPrompt />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PanelHeader from "@/components/conversational-commerce/PanelHeader";
import BrandDropdown from "@/components/conversational-commerce/BrandDropdown";
import InboxPanel from "@/components/conversational-commerce/InboxPanel";
import ProductListingPanel from "@/components/conversational-commerce/ProductListingPanel";
import AddOrderModal from "@/components/conversational-commerce/AddOrderModal";
import CartContents from "@/components/conversational-commerce/CartContents";
import ProductViewModal from "@/components/conversational-commerce/ProductViewModal";
import ThreadPanel from "@/components/conversational-commerce/ThreadPanel";
import ChangeBranchPrompt from "@/components/conversational-commerce/ChangingBranchPromptModal";

const is_free_trial = document.getElementsByClassName('free-trial');

export default {
  components: { PanelHeader, BrandDropdown, InboxPanel, ProductListingPanel, AddOrderModal, CartContents, ProductViewModal, ThreadPanel, ChangeBranchPrompt },
  data() {
    return {
      free_trial_height: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedOrder: "conversationalCommerce/selectedOrder",
      cartItems: "conversationalCommerce/cartItems"
    }),
    customerName: {
      get() {
        if (this.selectedOrder) return this.selectedOrder.name;
        else return;
      },
      set(customer) {
        return customer;
      }
    },
    isFreeTrialStyle: {
      get() {
        return {
          "--free-trial-height": `${this.free_trial_height}px`
        }
      },
      set(style) {
        return style;
      }
    }
  },
  created() {
    this.$store.dispatch("conversationalCommerce/isMultiplePurchaseAllowed");
    this.isFreeTrial();
  },
  beforeDestroy() {
    this.$store.commit("conversationalCommerce/setSelectedCategory", null);
    document.body.style.overflowY = null;
  },
  methods: {
    showCartItems() {
      this.$store.commit("conversationalCommerce/setShowCartItems", true);
    },
    isFreeTrial() {
      document.body.style.overflowY = "hidden";
      if (is_free_trial) this.free_trial_height = is_free_trial[0].parentElement.parentElement.clientHeight;
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');

#conversational-commerce-page {
  min-height: calc(100vh - var(--free-trial-height));
  overflow: hidden;
  & > * {
    font-family: MainFontRegular, sans-serif;
  }
  & > .row {
    height: calc(100% - var(--free-trial-height)) !important;
  }
  .cc-center-tools {
    #cc-cart {
      width: 19.5px;
      height: 18px;
      background: url('~@/assets/images/icons/shopping-cart.svg') no-repeat center;
      .cart-count {
        background: #FF2D2D;
        border-radius: 15px;
        color: #fff;
        font-family: MainFontBold, sans-serif;
        font-weight: normal;
        font-size: 12px;
        top: -16px;
        right: -12px;
      }
    }
    #cc-three-dots {
      width: 19px;
      height: 5px;
      background: url('~@/assets/images/icons/three-dots.svg') no-repeat center;
    }
  }
  #cc-settings {
    width: 24px;
    height: 24px;
    background: url('~@/assets/images/icons/settings.svg') no-repeat center;
  }
  #cc-goback {
    border: 1.5px solid #D8DCDE;
    border-radius: 50px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    font-size: 14px;
    color: #68737D;
  }
}
</style>
